import {
  ReturnLogsTypeEnum,
  settingsCreateMutation,
  settingsRetrieveOptions
} from '@crm/api'
import { useStyles } from '@crm/features/settings/styles'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation, useQuery } from '@tanstack/react-query'
import { App, Button, Card, Flex, Form, Input, Select } from 'antd'
import { useEffect } from 'react'

export const Settings = () => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const { styles } = useStyles()

  const { notification } = App.useApp()

  const { data, isLoading } = useQuery(settingsRetrieveOptions())

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data)
    }
  }, [data])

  const mutation = useMutation({
    ...settingsCreateMutation(),
    onError: (e) => showApiErrors(e),
    onSuccess: () => {
      notification.success({
        message: t('success.success'),
        description: t('success.success_data_save')
      })
    }
  })

  const onSubmit = () => {
    const { pbx_value, follow_up_limit, ...rest } = form.getFieldsValue()
    mutation.mutate({
      body: {
        ...rest,
        ...(follow_up_limit && { follow_up_limit }),
        ...(pbx_value && { pbx_value: parseFloat(pbx_value) })
      }
    })
  }

  return (
    <>
      <TitleSection title={t('admin_settings.settings')} />

      <Card className={styles.container} loading={isLoading}>
        <Form form={form} layout="vertical" onFinish={onSubmit}>
          <Form.Item
            name="log_types"
            label={<b>{t('admin_settings.communication_feed')}</b>}
            rules={[
              {
                required: true,
                message: t('account_settings.this_field_is_required')
              }
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Select"
              options={Object.values(ReturnLogsTypeEnum).map((item) => ({
                label: t(`logs.${item}`),
                value: item
              }))}
            />
          </Form.Item>

          <Form.Item
            name="follow_up_limit"
            rules={[
              {
                required: true,
                message: t('account_settings.this_field_is_required')
              }
            ]}
            label={
              <b>
                {t('admin_settings.text_on_settings')}
                <span style={{ color: '#0052cc' }}>
                  &quot;{t('admin_settings.span_on_settings')}&quot;
                </span>
              </b>
            }
          >
            <Input placeholder="0" type="number" />
          </Form.Item>

          <Form.Item
            name="pbx_value"
            label="PBX Cost"
            rules={[
              {
                required: true,
                message: t('account_settings.this_field_is_required')
              }
            ]}
          >
            <Input placeholder="0" type="number" />
          </Form.Item>

          <Flex justify="end">
            <Button type="primary" htmlType="submit">
              {t('buttons.save')}
            </Button>
          </Flex>
        </Form>
      </Card>
    </>
  )
}
